export class VenueAddress {
    id: string;

    addressStreet: string;

    addressCity: string;

    addressState: string;

    addressPostcode: string;

    addressCountry: string;
}
